const getMutationTypes = type => ({
  SUCCESS: `${type.toUpperCase()}_SUCCESS`,
  PENDING: `${type.toUpperCase()}_PENDING`,
  FAILURE: `${type.toUpperCase()}_FAILURE`,
});

export const INVENTORY_MUTATIONS = getMutationTypes('GET_INVENTORY');
export const USER_AUTH_MUTATIONS = getMutationTypes('USER_AUTH');
export const NETS_PAYMENT_MUTATIONS = getMutationTypes('NETS_PAYMENT');
export const PAYTRAIL_PAYMENT_MUTATIONS = getMutationTypes('PAYTRAIL_PAYMENT');
export const REFILL_VOUCHER_MUTATIONS = getMutationTypes('REFILL_VOUCHER');
export const CAMPAIGN_MUTATIONS = getMutationTypes('CAMPAIGN');
export const ROAMING_RCC_MUTATIONS = getMutationTypes('ROAMING_RCC');
export const SAFETY_NUMBER_GET_MUTATIONS = getMutationTypes(
  'SAFETY_NUMBER_GET'
);
export const SAFETY_NUMBER_SET_MUTATIONS = getMutationTypes(
  'SAFETY_NUMBER_SET'
);
export const ACCOUNT_HISTORY_MUTATIONS = getMutationTypes('ACCOUNT_HISTORY');
export const PAUSE_STATE_ENABLE_MUTATIONS = getMutationTypes(
  'PAUSE_STATE_ENABLE'
);
export const PAUSE_STATE_DISABLE_MUTATIONS = getMutationTypes(
  'PAUSE_STATE_DISABLE'
);
